import {
  Input,
  Output,
  OnInit,
  OnDestroy,
  Component,
  EventEmitter,
} from '@angular/core';

import { Subscription } from 'rxjs';
import { Address } from 'src/app/core';

import {
  AddressService,
  AddressServiceEvent,
} from 'src/app/feature/payment/services/address.service';

@Component({
  selector: 'app-address-container',
  templateUrl: './address-container.component.html',
  styleUrls: ['./address-container.component.sass'],
})
export class AddressContainerComponent implements OnInit, OnDestroy {
  @Input('addresses') addressArray: Address[] = [];
  @Input('selectable') isSelectable: boolean = false;
  @Input('selectedAddress') selectedAddress!: Address | undefined;
  @Output() selectedAddressChange = new EventEmitter<Address | undefined>();

  // Outputs ----------------------------------->

  @Output('onAddressSelect') selectEvent: EventEmitter<any> =
    new EventEmitter();

  // Properties -------------------------------->

  contentLoaded?: boolean = false;
  defaultSelectedAddress: number = 0;
  addressEventSubscription!: Subscription;

  // Accessors --------------------------------->

  public get selectedAddressPointer(): Address | undefined {
    return this.addressArray[this.defaultSelectedAddress] || undefined;
  }

  // Constructors ------------------------------>
  constructor(private addressService: AddressService) {}
  ngOnInit(): void {
    this.addressEventSubscription = this.addressService.status$.subscribe(
      (event) => {
        if (event?.payload) {
          this.onAddressEvent(event);
        }
      }
    );

    this.addressService.getUserAddresses().subscribe((addresses) => {
      this.addressArray = addresses;
      this.contentLoaded = true;
    });

    setTimeout(() => {
      const index = this.addressArray.findIndex(
        (address) => address.id === this?.selectedAddress?.id
      );
      this.select(index > 0 ? index : this.defaultSelectedAddress);
    }, 500);
  }

  // Public methods ---------------------------->

  select(i: number) {
    console.log(i);
    this.defaultSelectedAddress = i;
    this.selectEvent.emit(this.selectedAddressPointer);
    this.selectedAddressChange.emit(this.addressArray[i]);
  }

  public isSelected(address: Address) {
    return this?.selectedAddress?.id === address?.id;
  }

  private onAddressEvent(event: AddressServiceEvent) {
    switch (event.name) {
      case 'create':
        this.addressArray.push(event.payload as Address);
        if (this.addressArray.length === 1) {
          this.selectEvent.emit(this.selectedAddressPointer);
        }
        break;

      default:
        break;
    }
  }

  ngOnDestroy() {}
}
